<div class="bank-card" [style.background-color]="color" [style.width.px]="expirationDate ? 144 : 98">
  <div class="information">
    <div class="name" *ngIf="accessMedia?.accessMediaHolder?.accessMediaName">{{ accessMedia.accessMediaHolder.accessMediaName }}</div>
    <div class="pan">
      {{ accessMedia?.accessMediaDescription | truncateMaskedPan:'#' }}</div>
  </div>
  <div *ngIf="expirationDate" class="expiration-date">Exp.<br/>{{ accessMedia.accessMediaExpirationDate | localizedDate: 'MM/yy' }}</div>
</div>
